import {Grid} from '@primer/react-brand'

import {ContentfulInlineFootnotesList} from '@github-ui/swp-core/components/contentful/ContentfulInlineFootnotesList'
import {useFootnotes} from '@github-ui/swp-core/components/contentful/FootnotesContext'

import styles from './Footnotes.module.css'

export function Footnotes() {
  const {footnotes} = useFootnotes() || {}
  const hasFootnotes = footnotes && footnotes.length > 0

  if (hasFootnotes) {
    return (
      <Grid id="footnotes">
        <Grid.Column span={12}>
          <ContentfulInlineFootnotesList className={styles.footnotes} />
        </Grid.Column>
      </Grid>
    )
  }

  return null
}
